import React, { useState, useEffect } from "react";
import {
  acceptMultiplePendingBookingOrders,
  deleteBookingOrder,
  getBookingList,
  updateNewBookingOrderStatus,
} from "src/services/booking.services";
import { getUsedSearchedPlasticSealList } from "src/services/plastic-seal.services";
import { getSearchableStoreList } from "../../services/store.services";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CTable,
  CRow,
  CCol,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CFormInput,
  CFormCheck,
  CModal,
  CModalHeader,
  CModalBody,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPencil, cilPeople, cilPlus, cilTrash } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import NewBookingOrderActionModal from "../../components/NewBookingOrderActionModal/NewBookingOrderActionModal";
import Select from "react-select";
import toast from "react-hot-toast";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import { getActiveCountryList } from "src/services/country.services";
import { getSearchAbleRoutes } from "src/services/route.services";
import moment from "moment";
import ReactDatePicker from "react-datepicker";
import { BsChevronDoubleUp, BsChevronDoubleDown } from "react-icons/bs";
import SinglAssignTrip from "src/components/NewBookingOrderActionModal/SinglAssignTrip";
import { createMultipleOrders } from "src/services/trip.services";
import BulkAssignTrip from "src/components/NewBookingOrderActionModal/BulkAssignTrip";
import useTableSort from "src/__custom_hook/useTableSort";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";
import { QueryClient, useMutation } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import useExportData from "src/__custom_hook/useExportData";

const NewBookingOrdersTable = () => {
  const queryClient = new QueryClient();
  const { exportData } = useExportData();
  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );

  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();

  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [type, setType] = useState("new-cvit");
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [modalText, setModalText] = useState(null);
  const [
    visibleNewBookingOrderActionModal,
    setVisibleNewBookingOrderActionModal,
  ] = useState(false);
  const [modalErrorText, setModalErrorText] = useState("");
  const [reportComment, setReportComment] = useState("");

  const [bookingOrderId, setBookingOrderId] = useState("");
  const [transferOrderNo, setTransferOrderNo] = useState("");
  const [sealBag, setSealBag] = useState("");
  const [activeCountries, setActiveCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [tripRoute, setTripRoute] = useState("");
  const [tripName, setTripName] = useState("");
  const [bookingOrderStatus, setBookingOrderStatus] = useState("");
  const [selectedFromStoreOption, setSelectedFromStoreOption] = useState(null);
  const [selectedToStoreOption, setSelectedToStoreOption] = useState(null);
  const [storeDataArray, setStoreDataArray] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [locationCodeOptions, setLocationCodeOptions] = useState(null);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteOption, setSelectedRouteOption] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedSealOption, setSelectedSealOption] = useState(null);
  const [sealOptions, setSealOptions] = useState([]);
  const [sealArray, setSealArray] = useState([]);
  const [selectedFromLocationCode, setSelectedFromLocationCode] = useState("");
  const [selectedToLocationCode, setSelectedToLocationCode] = useState("");

  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [priorityOptions, setPriorityOptions] = useState([
    { label: "normal", value: "normal" },
    { label: "emergency", value: "emergency" },
  ]);
  const [selectedPriorityOption, setSelectedPriorityOption] = useState(null);
  const [priority, setPriority] = useState("");
  const [bookingOrderSelectedStatus, setBookingOrderSelectedStatus] =
    useState("");

  //assigne modal visibility
  const [selectedModalBookingoOrderId, setSelectedModalBookingoOrderId] =
    useState(null);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [bulkTripId, setBulkTripId] = useState(null);

  const [isAccepting, setIsAccepting] = useState(false);

  const [showConfirmAllModal, setShowConfirmAllModal] = useState(false);

  // Create Multiple orders trip mutation
  const AssignMultipleTripMutation = useMutation({
    mutationKey: ["assign-multiple-trip"],
    mutationFn: (data) => createMultipleOrders(data),
    onMutate: () => {
      toast.loading("Loading....");
    },
    onSuccess: (res) => {
      toast.dismiss();
      const result = res.data;

      if (result) {
        const tripId = result.id;
        setBulkTripId(tripId);
        // if (
        //   selectedPriorityOption &&
        //   selectedPriorityOption.value === "emergency"
        // ) {
        //   const country = selectedCountry?.value;
        //   navigate(
        //     `/create-bulk-trip/${tripId}?priority=emergency${
        //       country ? "&country=" + country : ""
        //     }`,
        //     {
        //       replace: true,
        //     }
        //   );
        // } else {
        //   navigate("/create-bulk-trip/" + tripId, {
        //     replace: true,
        //   });
        // }
      }
    },
    onError: (error) => {
      console.log(error);
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
    onSettled: () => {
      queryClient.invalidateQueries(["assign-multiple-trip"]);
    },
  });

  // Accept all order mutation
  const acceptAllBookingOrderMutation = useMutation({
    mutationKey: ["acceptAll"],
    mutationFn: (data) => acceptMultiplePendingBookingOrders(data),
    onMutate: () => {
      toast.loading("Loading.....");
    },
    onSuccess: (res) => {
      console.log(res);
      toast.dismiss();

      if (res.data.success) {
        toast.success(res.data.message || "Opration success");
        setSelectedCheckboxes([]);
        setSelectAllStatus(false);
        setShowConfirmAllModal(false);
        getNewBookingItem(1);
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    },
  });

  //delete booking order mutation
  const deleteBookingOrderMutation = useMutation({
    mutationKey: ["delete-booking-order"],
    mutationFn: (id) => deleteBookingOrder(id),
    onMutate: () => {
      toast.loading("Deleting booking order....");
    },
    onSuccess: (response) => {
      toast.dismiss();
      toast.success(response.message || "Booking order deleted successfully");
      getNewBookingItem(currentPage || 1);
    },
    onError: (error) => {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
    onSettled: () => {
      queryClient.invalidateQueries(["delete-booking-order"]);
    },
  });

  useEffect(() => {
    if (localUser?.country) {
      setSelectedCountry({
        value: localUser.country._id,
        label: `${localUser.country.name}-${localUser.country.code}`,
      });
    }

    if (localUser?.userType === "superAdmin") {
      getActiveCountries();
    } else {
      getStoreInfo();
      getRouteNameList();
      getUsedSealInfo();
    }

    getNewBookingItem(currentPage);
    getStatusList();
  }, []);

  useEffect(() => {
    if (localUser?.userType === "superAdmin") {
      if (selectedCountry) {
        getStoreInfo(selectedCountry?.value);
        getRouteNameList(selectedCountry?.value);
        getUsedSealInfo("", selectedCountry?.value);
      } else {
        getStoreInfo();
        getRouteNameList();
        getUsedSealInfo();
      }
      // getNewBookingItem(currentPage);
    }
  }, [selectedCountry]);

  const handleToggleFields = () => {
    setShowAdditionalFields((prev) => !prev);
  };

  const handleSubmit = () => {
    setCurrentPage(1);
    setSelectAllStatus(false);
    setSelectedCheckboxes([]);
    getNewBookingItem(1);
  };

  const handleReset = () => {
    setBookingOrderId("");
    setSelectedSealOption("");
    setSealBag("");
    setTransferOrderNo("");
    setFromDate("");
    setToDate("");
    setFromTime("");
    setToTime("");

    setTripName("");

    if (sortConfig.length > 0) {
      setSortConfig([]);
    }

    setSelectedToStoreOption("");
    setSelectedFromLocationCode("");
    setToLocation("");

    setSelectedFromStoreOption("");
    setSelectedToLocationCode("");
    setFromLocation("");
    setSelectedPriorityOption("");
    setPriority("");

    setSelectedRouteOption("");
    setTripRoute("");

    setSelectedPriorityOption("");
    setBookingOrderSelectedStatus("");
    if (selectedCountry) {
      setSelectedCountry(null);
    }

    setCurrentPage(1);
    getNewBookingItem(1);
  };

  //get all active countries
  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1, status: true })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setActiveCountries(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getStoreInfo = (country = "") => {
    getSearchableStoreList({ country })
      .then(async (response) => {
        setStoreDataArray(response.data);
        const storeData = response.data;
        let options = [];
        let locationCodeOptions = [];
        storeData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          const codeOption = {
            value: `${element._id}`,
            label: element.locationCode ? element.locationCode : "N/A",
          };
          options.push(option);
          locationCodeOptions.push(codeOption);
        });
        setStoreOptions(options);
        setLocationCodeOptions(locationCodeOptions);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getNewBookingItem = (page) => {
    setIsLoading(true);
    const fromDateFormat = fromDate
      ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";
    const toDateFomrat = toDate
      ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";

    if (fromDate && toDate) {
      if (moment(toDate).isBefore(moment(fromDate))) {
        toast.error("To date cannot be before from date");
        return;
      }
    }
    const params = {
      limit,
      page: page,
      type,
      bookingOrderId,
      sealBag,
      tripName,
      transferOrderNo,
      fromLocation: fromLocation,
      toLocation: toLocation,
      from: fromDateFormat,
      to: toDateFomrat,
      fromTime: fromTime,
      toTime: toTime,
      tripRoute: tripRoute,
      priority,
      status: bookingOrderSelectedStatus
        ? bookingOrderSelectedStatus.value
        : "",
      country: selectedCountry ? selectedCountry?.value : "",
      sort: sortConfig
        .map((config) => `${config.key}:${config.direction}`)
        .join(","),
    };
    getBookingList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);

        // if (selectAllStatus) {
        //   let selectedItems = [];
        //   response.data.map((item) => {
        //     if (item.status === "cvit") {
        //       selectedItems.push(item._id);
        //     }
        //   });
        //   setSelectedCheckboxes((prev) => [...prev, ...selectedItems]);
        // }

        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage((prev) => newPage);
    getNewBookingItem(newPage);
    if (selectAllStatus && bookingOrderSelectedStatus) {
      let selectedItems = [];
      data.map((item) => {
        if (item.status === "cvit") {
          selectedItems.push(item._id);
        }
      });
      setSelectedCheckboxes((prev) => [...prev, ...selectedItems]);
    }
  };

  const handleChangeAcceptance = (selectedOption, id) => {
    setVisibleNewBookingOrderActionModal(true);
    setSelectedId(id);
    setSelectedOption(selectedOption);
    const newData = data;
    const objectIndex = newData.findIndex((x) => x._id === id);
    newData[objectIndex].status = selectedOption;
    setData(newData);
    setModalErrorText("");
    if (selectedOption == "accepted") {
      setModalText("Are you  sure to accept this order?");
    } else if (selectedOption == "rejected") {
      setModalText(
        "Are you  sure to reject this order? If yes please write the reason:"
      );
    }
  };

  const handleReportComment = (value) => {
    setReportComment(value);
    if (value) {
      setModalErrorText("");
    } else {
      setModalErrorText("Please write the reject reason in comment box!");
    }
  };

  const handleConfirm = (value) => {
    if (value == "confirm") {
      let data = {
        status: selectedOption,
      };
      if (selectedOption === "rejected") {
        if (!reportComment) {
          setModalErrorText("Please write the reject reason in comment box!");
          return;
        } else {
          data.rejectReason = reportComment;
        }
      }
      setVisibleNewBookingOrderActionModal(false);

      toast
        .promise(
          updateNewBookingOrderStatus(data, selectedId),
          {
            loading: () => {
              setIsAccepting(true);
              return "Loading...";
            },
            success: () => {
              setIsAccepting(false);
              return "Order Status changed succesfully";
            },
            error: (err) => {
              setIsAccepting(false);
              console.log(err);
              return "Something went wrong.";
            },
          },
          {
            id: "booking-order-status",
          }
        )
        .then(async (response) => {
          getNewBookingItem(currentPage);
        })
        .catch((error) => {
          setIsAccepting(false);
          console.error(error);
        });
    } else {
      setVisibleNewBookingOrderActionModal(false);
      const newData = data;
      const objectIndex = newData.findIndex((x) => x._id === selectedId);
      newData[objectIndex].status = "pending";
      setData(newData);
    }
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
    setFromLocation(null);
    setSelectedFromLocationCode("");
    setSelectedFromStoreOption(null);
    setToLocation(null);
    setSelectedToLocationCode("");
    setSelectedToStoreOption(null);
    setSealBag(null);
    setSelectedSealOption(null);
    setTripRoute("");
    setSelectedRouteOption(null);
  };

  const handleChangeFromStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromStoreOption(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
    } else {
      setSelectedFromLocationCode("");
      setSelectedFromStoreOption("");
      setFromLocation("");
    }
  };
  const handleChangeFromLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromLocationCode(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromStoreOption({ value: storeObj._id, label: storeObj.name });
    } else {
      setSelectedFromLocationCode("");
      setSelectedFromStoreOption("");
      setFromLocation("");
    }
  };

  const handleChangeToStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedToStoreOption(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedToLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeToLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedToLocationCode(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
      setSelectedToStoreOption({ value: storeObj._id, label: storeObj.name });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeSeal = (selectedOption) => {
    if (selectedOption) {
      setSelectedSealOption(selectedOption);
      setSealBag(selectedOption.value);
    } else {
      setSelectedSealOption("");
      setSealBag("");
    }
  };

  const handleOnInputChangeSeal = (selectedOption) => {
    if (selectedOption) {
      const expectedData = sealArray.find((a) => a.includes(selectedOption));
      if (!expectedData) {
        getUsedSealInfo(selectedOption, selectedCountry?.value ?? "");
      }
    } else {
      getUsedSealInfo();
    }
  };

  const getRouteNameList = (country = "", searchString = "") => {
    getSearchAbleRoutes({ country, searchString })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];

        fetchedRouteData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
        });

        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChangePriority = (selectedOption) => {
    if (selectedOption) {
      setSelectedPriorityOption(selectedOption);
      setPriority(selectedOption.value);
    } else {
      setSelectedPriorityOption("");
      setPriority("");
    }
  };

  const getStatusList = () => {
    const statusObj = [
      // {name:"All",value:''},
      // {name:"CDT",value:'cvit'},
      { name: "Accepted", value: "new" },
      { name: "Pending", value: "pending" },
      { name: "Assigned", value: "assigned" },
      { name: "Accepted(Driver)", value: "driver" },
      // { name: "Delivered", value: "delivered" },
      // {name:"Rejected",value:'rejected'},
      // {name:"Active",value:'active'},
    ];
    let options = [];
    statusObj.forEach((element) => {
      const option = { value: `${element.value}`, label: `${element.name}` };
      options.push(option);
    });
    setStatusOptions(options);
  };

  const handleChangeStatus = async (selectedOption) => {
    setSelectedCheckboxes([]);
    if (selectedOption) {
      setBookingOrderSelectedStatus(selectedOption);
      setBookingOrderStatus(selectedOption.value);
    } else {
      setBookingOrderSelectedStatus("");
      setBookingOrderStatus("");
      setSelectAllStatus(false);
    }
  };

  const handleChangeRoute = (selectedOption) => {
    if (selectedOption) {
      setSelectedRouteOption(selectedOption);
      setTripRoute(selectedOption.value);
    } else {
      setSelectedRouteOption("");
      setTripRoute("");
    }
  };
  const handleOnInputChangeRoute = (searchValue) => {
    if (searchValue) {
      const matchingRoutes = routeOptions.filter((route) =>
        route.label.toLowerCase().includes(searchValue.toLowerCase())
      );
      if (matchingRoutes.length <= 0) {
        getRouteNameList(searchValue);
      }
    }
  };

  const getUsedSealInfo = (searchedString = "", country = "") => {
    const limit = 10;
    const page = 1;
    getUsedSearchedPlasticSealList({ limit, page, searchedString, country })
      .then(async (response) => {
        const storeData = response.data;
        let options = [];
        let serialArray = [];

        storeData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${element.serialNo}`,
          };
          options.push(option);
          serialArray.push(element.serialNo);
        });
        setSealArray(serialArray);
        setSealOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleDateChange = (date, identity) => {
    if (!identity) return;
    if (!date) {
      // Clear the date if the input is empty
      if (identity === "from") {
        setFromDate("");
      } else if (identity === "to") {
        setToDate("");
      }
      return;
    }
    const today = moment().toDate();
    if (identity === "from") {
      if (date && moment(today).diff(moment(date), 'days') > 30) {
        const next30Days = moment(date).add(30, 'days').toDate();
        setToDate(next30Days);
      }

      setFromDate(date);

    }
    if (identity === "to") setToDate(date);
  };

  const handleCheckBox = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    if (selectAllStatus) {
      setSelectAllStatus(false);
    }
    if (selectedCheckboxes.includes(value)) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((item) => item !== value)
      );
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, value]);
    }
  };

  const handleAllSelectCheckBox = (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (localUser.userType === "superAdmin" && !selectedCountry) {
      toast.error("Please select a country and try again");
      return;
    }

    if (!bookingOrderSelectedStatus || !bookingOrderSelectedStatus.value) {
      toast.error("Please select a status and try again");
      return;
    }

    const isChecked = event.target.checked;

    setSelectAllStatus(isChecked);
    let selectedOders = [];

    if (
      bookingOrderSelectedStatus &&
      bookingOrderSelectedStatus.value === "pending"
    ) {
      selectedOders = data.reduce((ids, item) => {
        if (localUser.userType === "superAdmin") {
          console.log("herer");
          if (
            item.status === "pending" &&
            item.country._id === selectedCountry.value
          ) {
            ids.push(item._id);
          }
        } else {
          console.log("herer");
          if (item.status === "pending") {
            ids.push(item._id);
          }
        }

        return ids;
      }, []);
    }

    if (
      bookingOrderSelectedStatus &&
      bookingOrderSelectedStatus.value === "new"
    ) {
      data.map((item) => {
        if (localUser.userType === "superAdmin") {
          if (
            item.status === "cvit" &&
            item.country._id === selectedCountry.value
          ) {
            selectedOders.push(item._id);
          }
        } else if (item.status === "cvit") {
          selectedOders.push(item._id);
        } else {
          console.log("not checked");
        }
      });
    }

    if (isChecked) {
      setSelectedCheckboxes(selectedOders);
    } else {
      setSelectedCheckboxes([]);
    }
  };

  const createMultipleOrder = async () => {
    if (selectedCheckboxes.length < 1) {
      toast("Here is your toast.");
    }

    const fromDateFormat = fromDate
      ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";
    const toDateFomrat = toDate
      ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";

    if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
      toast.error("To date cannot be before from date");
      return;
    }

    const params = {
      bookingOrders: selectedCheckboxes,
      status: "new-cvit",
      selectAllStatus,
      bookingOrderId,
      sealBag,
      transferOrderNo,
      priority,
      fromLocation,
      toLocation,
      fromDate: fromDateFormat,
      toDate: toDateFomrat,
      fromTime,
      toTime,
      country: selectedCountry?.value || null,
      tripRoute: tripRoute || selectedRouteOption?.value || null,
      from: fromDateFormat,
      to: toDateFomrat,
      fromTime: fromTime,
      toTime: toTime,
      country: selectedCountry ? selectedCountry.value : "",
    };

    if (localUser?.userType === "superAdmin" && !selectedCountry?.value) {
      setSelectAllStatus(false);
      toast.error("Please select a country and try again");
      return;
    } else {
      params.country = selectedCountry?.value;
    }

    AssignMultipleTripMutation.mutate(params);

    // if (priority === "emergency") {
    //   createMultipleOrders(params)
    //     .then(async (response) => {
    //       setIsLoading(false);
    //       const tripId = response.data?.id;
    //       navigate(
    //         `/create-bulk-trip/${tripId}?priority=emergency${
    //           params.country ? "&country=" + params.country : ""
    //         }`,
    //         {
    //           replace: true,
    //         }
    //       );
    //     })
    //     .catch((error) => {
    //       setIsLoading(false);
    //       console.error(error);
    //     });
    // } else {
    //   createMultipleOrders(params)
    //     .then(async (response) => {
    //       setIsLoading(false);
    //       const tripId = response.data?.id;
    //       setBulkTripId(tripId);
    //     })
    //     .catch((error) => {
    //       setIsLoading(false);
    //       console.error(error);
    //     });

    // let referenceOrder = data.find(
    //   (order) => order._id === selectedCheckboxes[0]
    // );
    // let tripId =
    //   referenceOrder?.tripRoute?._id || referenceOrder?.toLocation?.route;
    // if (referenceOrder && tripId) {
    //   const selectedFilteredOrders = data.filter((order) =>
    //     selectedCheckboxes.includes(order._id)
    //   );

    //   const allOrdersHaveSameRoute = selectedFilteredOrders.every(
    //     (item) => item?.tripRoute?._id === tripId
    //   );

    //   if (allOrdersHaveSameRoute) {
    //     const params = {
    //       bookingOrders: selectedCheckboxes,
    //     };
    //     createMultipleOrders(params)
    //       .then(async (response) => {
    //         setIsLoading(false);
    //         const tripId = response.data?.id;
    //         setBulkTripId(tripId);
    //         // navigate("/create-bulk-trip/" + tripId, {
    //         //   replace: true,
    //         // });
    //       })
    //       .catch((error) => {
    //         setIsLoading(false);
    //         console.error(error);
    //       });
    //   } else {
    //     setSelectAllStatus(false);
    //     setSelectedCheckboxes([]);
    //     toast.error(
    //       "Please select the orders from same route to assign trip"
    //     );
    //   }
    // } else {
    //   toast.error("To Location is not assigned to any route");
    // }
    // }
  };


  const exportToExcel = async () => {
    try {
      toast.loading("Preparing downloads...");

      const fromDateFormat = fromDate
        ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";
      const toDateFomrat = toDate
        ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";

      if (fromDate && toDate && moment(toDate).isBefore(moment(fromDate))) {
        toast.error("To date cannot be before from date");
        return;
      }

      const params = {
        bookingOrderId,
        type,
        sealBag,
        tripName,
        transferOrderNo,
        fromLocation: fromLocation,
        toLocation: toLocation,
        from: fromDateFormat,
        to: toDateFomrat,
        fromTime: fromTime,
        toTime: toTime,
        tripRoute: tripRoute,
        priority,
        status: bookingOrderSelectedStatus
          ? bookingOrderSelectedStatus.value
          : "",
        country: selectedCountry ? selectedCountry.value : "",
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
        fileType: "excel",
      };

      exportData(params);
    } catch (error) {
      toast.dismiss();
      console.error(error);
    } finally {
      toast.dismiss();
    }
  };

  const acceptAllHandler = (action = null) => {
    if (
      bookingOrderSelectedStatus &&
      selectedCheckboxes.length > 0 &&
      !showConfirmAllModal &&
      !action
    ) {
      setShowConfirmAllModal(true);
      return;
    }

    if (
      bookingOrderSelectedStatus &&
      selectedCheckboxes.length > 0 &&
      showConfirmAllModal &&
      action
    ) {
      const fromDateFormat = fromDate
        ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";
      const toDateFomrat = toDate
        ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
        : "";

      if (toDate && fromDate && moment(toDate).isBefore(moment(fromDate))) {
        toast.error("To date cannot be before from date");
        return;
      }

      const data = {
        action,
        bookingOrders: selectedCheckboxes,
        selectAllStatus,
        country:
          localUser.userType === "superAdmin" && selectedCountry
            ? selectedCountry.value
            : null,
        bookingOrderId,
        sealBag,
        transferOrderNo,
        tripRoute,
        fromLocation,
        toLocation,
        fromDate: fromDateFormat,
        toDate: toDateFomrat,
        fromTime,
        toTime,
        priority,
      };
      acceptAllBookingOrderMutation.mutate(data);
      // do your api call etc
      // setShowConfirmAllModal(false);
    }
  };

  const handleCloseModal = () => {
    setBulkTripId(null);
    setSelectedCheckboxes([]);

    setSelectAllStatus(false);
    setShowConfirmAllModal(false);
    setCurrentPage(1);
    getNewBookingItem(1);
  };

  const handleDeleteBookingOrder = (id) => {
    deleteBookingOrderMutation.mutate(id);
  }

  useEffect(() => {
    if (selectAllStatus && bookingOrderSelectedStatus) {
      const selectedItems = data.reduce((acc, item) => {
        if (
          (bookingOrderSelectedStatus.value === "pending" &&
            item.status === "pending") ||
          (bookingOrderSelectedStatus.value === "new" && item.status === "cvit")
        ) {
          acc.push(item._id);
        }
        return acc;
      }, []);

      setSelectedCheckboxes((prev) => [...prev, ...selectedItems]);
    }
  }, [selectAllStatus, bookingOrderSelectedStatus, data]);

  useEffect(() => {
    if (sortConfig.length > 0) {
      setCurrentPage(1);
      getNewBookingItem(1);
    }
  }, [sortConfig]);

  return (
    <>
      {showConfirmAllModal && (
        <CModal
          backdrop="static"
          visible={showConfirmAllModal}
          onClose={() => {
            setSelectedCheckboxes([]);
            setSelectAllStatus(false);
            setShowConfirmAllModal(false);
          }}
        >
          <CModalHeader closeButton>
            <CModalTitle>Confirm</CModalTitle>
          </CModalHeader>
          <CModalBody>
            You have selected total{" "}
            {selectAllStatus ? count : selectedCheckboxes.length} booking
            orders. Are you sure you want to proceed?
          </CModalBody>
          <CModalFooter>
            <CButton
              color="dark"
              onClick={() => {
                setShowConfirmAllModal(false);
                setSelectedCheckboxes([]);
                setSelectAllStatus(false);
              }}
            >
              Cancel
            </CButton>
            <CButton
              color="danger"
              onClick={() => acceptAllHandler("rejected")}
            >
              Reject All
            </CButton>
            <CButton
              color="success"
              onClick={() => acceptAllHandler("accepted")}
            >
              Accept All
            </CButton>
          </CModalFooter>
        </CModal>
      )}
      <CCard className="mb-4">
        <CCardBody>
          <div className="position-absolute p-2 top-0 end-0">
            <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={handleToggleFields}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton>
          </div>
          <CRow className="mb-1">
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">
                Booking Order ID:
              </CFormLabel>
              <CFormInput
                type="text"
                value={bookingOrderId}
                onChange={(e) => setBookingOrderId(e.target.value)}
                placeholder="example:DD001"
              />
            </CCol>

            <CCol sm={12} md={6}>
              <CRow>
                <CCol sm={12} md={5}>
                  <CFormLabel>Transfer Order No.</CFormLabel>
                  <CFormInput
                    type="text"
                    placeholder="example:DD001"
                    value={transferOrderNo}
                    onChange={(e) => setTransferOrderNo(e.target.value)}
                  />
                </CCol>
                {/* <CCol md={5}>
                  <CFormLabel htmlFor="bookingOrderId">Trip Name:</CFormLabel>
                  <CFormInput
                    type="text"
                    value={tripName}
                    onChange={(e) => setTripName(e.target.value)}
                    placeholder="example trip"
                  />
                </CCol> */}
                <CCol sm={7}>
                  <CFormLabel htmlFor="bookingOrderId">Route Name:</CFormLabel>
                  <Select
                    value={selectedRouteOption}
                    onChange={handleChangeRoute}
                    onInputChange={handleOnInputChangeRoute}
                    options={routeOptions}
                    isClearable={true}
                  />
                </CCol>
              </CRow>
            </CCol>

            <CCol sm={3}>
              <CRow className="mb-1">
                {localUser && localUser.userType === "superAdmin" && (
                  <CCol sm={7} md={7}>
                    <CFormLabel>Country:</CFormLabel>

                    <Select
                      value={selectedCountry}
                      onChange={handleCountryChange}
                      options={activeCountries}
                      isClearable={true}
                    />
                  </CCol>
                )}

                <CCol
                  sm={localUser && localUser.userType === "superAdmin" ? 5 : 12}
                >
                  <CFormLabel htmlFor="bookingOrderId">Status:</CFormLabel>
                  <Select
                    value={bookingOrderSelectedStatus}
                    onChange={handleChangeStatus}
                    options={statusOptions}
                    isClearable={true}
                  />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          {/* Additional fields with transitions */}
          <div
            style={{
              maxHeight: showAdditionalFields ? "100%" : "0",
              transition: "max-height 0.5s ease",
            }}
          >
            {showAdditionalFields && (
              <>
                <CRow className="mb-1">
                  <CCol sm={12} md={3}>
                    <CFormLabel htmlFor="orderNumber">Priority:</CFormLabel>
                    <Select
                      value={selectedPriorityOption}
                      onChange={handleChangePriority}
                      options={priorityOptions}
                      isClearable={true}
                      className="text-capitalize"
                    />
                  </CCol>
                  {/* <CCol sm={12} md={3}>
                    <CFormLabel>Transfer Order No.</CFormLabel>
                    <CFormInput
                      type="text"
                      placeholder="example:DD001"
                      value={transferOrderNo}
                      onChange={(e) => setTransferOrderNo(e.target.value)}
                    />
                  </CCol> */}

                  <CCol sm={12} md={6}>
                    <CRow>
                      <CCol sm={5}>
                        <CFormLabel htmlFor="fromLocationCode">
                          From Location Code:
                        </CFormLabel>
                        <Select
                          id="fromLocationCode"
                          value={selectedFromLocationCode}
                          onChange={handleChangeFromLocationCode}
                          options={locationCodeOptions}
                          isClearable={true}
                        />
                      </CCol>
                      <CCol sm={7}>
                        <CFormLabel htmlFor="fromLocationName">
                          From Location Name:
                        </CFormLabel>
                        <Select
                          id="fromLocationName"
                          value={selectedFromStoreOption}
                          onChange={handleChangeFromStore}
                          options={storeOptions}
                          isClearable={true}
                        // isDisabled={selectedCountry ? false : true}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol sm={12} md={3}>
                    <CRow>
                      <CFormLabel>From Date:</CFormLabel>
                      <CCol sm={7}>
                        <ReactDatePicker
                          showIcon={true}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          onChange={(date) => handleDateChange(date, "from")}
                          // value={fromDate}
                          selected={fromDate}
                        // isClearable={true}
                        />
                      </CCol>
                      <CCol sm={5}>
                        <CFormInput
                          type="time"
                          value={fromTime}
                          onChange={(e) => setFromTime(e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
                <CRow className="mb-1">
                  <CCol sm={12} md={3}>
                    <CFormLabel>Seal/Bag No.</CFormLabel>
                    <CCol sm={12}>
                      <Select
                        value={selectedSealOption}
                        onChange={handleChangeSeal}
                        onInputChange={handleOnInputChangeSeal}
                        options={sealOptions}
                        isClearable={true}
                      />
                    </CCol>
                  </CCol>
                  <CCol sm={12} md={6}>
                    <CRow className="mb-1">
                      <CCol sm={5}>
                        <CFormLabel htmlFor="toLocationCode">
                          To Location Code:
                        </CFormLabel>
                        <Select
                          id="toLocationCode"
                          value={selectedToLocationCode}
                          onChange={handleChangeToLocationCode}
                          options={locationCodeOptions}
                          isClearable={true}
                        />
                      </CCol>
                      <CCol sm={7}>
                        <CFormLabel htmlFor="toLocationName">
                          To Location Name:
                        </CFormLabel>
                        <Select
                          id="toLocationName"
                          value={selectedToStoreOption}
                          onChange={handleChangeToStore}
                          options={storeOptions}
                          isClearable={true}
                        />
                      </CCol>
                    </CRow>
                  </CCol>

                  <CCol sm={12} md={3}>
                    <CRow className="mb-1">
                      <CFormLabel htmlFor="bookingOrderId">To Date:</CFormLabel>
                      <CCol sm={7}>
                        <ReactDatePicker
                          showIcon={true}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          onChange={(date) => handleDateChange(date, "to")}
                          selected={toDate}
                        />
                      </CCol>
                      <CCol sm={5}>
                        <CFormInput
                          type="time"
                          value={toTime}
                          onChange={(e) => setToTime(e.target.value)}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </>
            )}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 me-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>

      <CCard className="mb-4">
        <CCardBody>
          <CRow sm={{ gutter: 4 }}>
            <CCol sm={7}>
              <h4 id="traffic" className="card-title mb-0">
                New Booking Orders - Total: {count}
              </h4>
            </CCol>
            <CCol sm={5}>
              <div className="d-flex justify-content-end gap-4">
                {["superAdmin", "admin", "cvit"].includes(localUser.userType) &&
                  selectedCheckboxes.length > 1 &&
                  bookingOrderSelectedStatus && (
                    <>
                      {bookingOrderSelectedStatus.value === "new" && (
                        <CButton onClick={() => createMultipleOrder()}>
                          <CIcon icon={cilPlus} />
                          &nbsp; Assign Trip
                        </CButton>
                      )}
                      {bookingOrderSelectedStatus.value === "pending" && (
                        <CButton onClick={() => acceptAllHandler()}>
                          <CIcon icon={cilPlus} />
                          &nbsp; Accept-Reject Multiple
                        </CButton>
                      )}
                    </>
                  )}

                <CButton onClick={exportToExcel}>Export</CButton>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                {["superAdmin", "admin", "cvit"].includes(
                  localUser.userType
                ) && (
                    <CTableHeaderCell className="text-center">
                      <CFormCheck
                        id="AllSelectBox"
                        onChange={handleAllSelectCheckBox}
                        checked={selectAllStatus}
                        disabled={["assigned", "driver"].includes(
                          bookingOrderSelectedStatus?.value
                        )}
                        style={{
                          width: "20px",
                          height: "20px",
                          margin: "0px 10px",
                        }}
                      />
                    </CTableHeaderCell>
                  )}

                <CTableHeaderCell>Status</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("bookingOrderId")}
                  style={{ cursor: "pointer" }}
                >
                  Booking Order Id{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "bookingOrderId" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("transferOrderNo")}
                  style={{ cursor: "pointer" }}
                >
                  Transfer Order No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "transferOrderNo" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("sealBag")}
                  style={{ cursor: "pointer" }}
                >
                  Seal/Bag No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "sealBag" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("country")}
                  style={{ cursor: "pointer" }}
                >
                  Country{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "country" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("fromLocation")}
                  style={{ cursor: "pointer" }}
                >
                  From Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "fromLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("toLocation")}
                  style={{ cursor: "pointer" }}
                >
                  To Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "toLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("type")}
                  style={{ cursor: "pointer" }}
                >
                  Type{" "}
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "type" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("unit")}
                  style={{ cursor: "pointer" }}
                >
                  Unit{" "}
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "unit" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("tripRoute")}
                  style={{ cursor: "pointer" }}
                >
                  Route Name{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "tripRoute" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell>Priority</CTableHeaderCell>
                <CTableHeaderCell
                  onClick={() => handleClickColumnSort("pickupDateTime")}
                  style={{ cursor: "pointer" }}
                >
                  Pick Up Date{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "pickupDateTime" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell>Pick Up Time</CTableHeaderCell>
                <CTableHeaderCell>Remarks</CTableHeaderCell>
                <CTableHeaderCell>
                  Created At{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "createdAt" }}
                  />
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="20">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="20">
                    No data available
                  </CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow
                    v-for="item in tableItems"
                    key={index}
                  >
                    {["superAdmin", "admin", "cvit"].includes(
                      localUser.userType
                    ) && (
                        <CTableDataCell
                          className="text-center"
                          style={{
                            cursor: bookingOrderSelectedStatus
                              ? "pointer"
                              : "not-allowed",
                          }}
                        >
                          <CFormCheck
                            id={item._id}
                            value={item._id}
                            disabled={
                              !bookingOrderSelectedStatus ||
                              ["assigned", "driver"].includes(item.status) ||
                              (bookingOrderSelectedStatus.value !== item.status &&
                                (bookingOrderSelectedStatus.value !== "new" ||
                                  item.status !== "cvit")) ||
                              (localUser.userType === "superAdmin" &&
                                !selectedCountry)
                            }
                            defaultChecked={selectedCheckboxes.includes(item._id)}
                            onClick={handleCheckBox}
                            style={{
                              width: "20px",
                              height: "20px",
                              margin: "0px 10px",
                              cursor: bookingOrderSelectedStatus
                                ? "pointer"
                                : "not-allowed",
                            }}
                          />
                        </CTableDataCell>
                      )}
                    <CTableDataCell className="text-capitalize">
                      {item.status === "pending" && (
                        <CButton
                          color="pink"
                          className="text-capitalize"
                          size="sm"
                        >
                          Pending
                        </CButton>
                      )}
                      {item.status === "cvit" && (
                        <CButton
                          color="lightBlue"
                          className="text-capitalize"
                          size="sm"
                        >
                          New
                        </CButton>
                      )}

                      {item.status === "assigned" && (
                        <CButton
                          color="gray"
                          className="text-capitalize"
                          size="sm"
                        >
                          Assigned
                        </CButton>
                      )}

                      {item.status === "driver" && (
                        <CButton
                          color="purple"
                          className="text-capitalize"
                          size="sm"
                        >
                          Accepted
                        </CButton>
                      )}
                    </CTableDataCell>

                    <CTableDataCell>
                      <CCol xs={12}>
                        <div className="d-flex gap-2">
                          {["superAdmin", "admin", "cvit"].includes(
                            localUser.userType
                          ) && (
                              <>
                                {item.status === "pending" ? (
                                  <>
                                    <CButton
                                      color="success"
                                      size="sm"
                                      disabled={isAccepting}
                                      onClick={() =>
                                        handleChangeAcceptance(
                                          "accepted",
                                          item._id
                                        )
                                      }
                                    >
                                      A
                                    </CButton>
                                    <CButton
                                      color="danger"
                                      size="sm"
                                      disabled={isAccepting}
                                      onClick={() =>
                                        handleChangeAcceptance(
                                          "rejected",
                                          item._id
                                        )
                                      }
                                    >
                                      R
                                    </CButton>
                                  </>
                                ) : (
                                  item.status === "cvit" && (
                                    <CButton
                                      color="primary"
                                      className="text-capitalize"
                                      size="sm"
                                      onClick={() => {
                                        setSelectedModalBookingoOrderId(item._id);
                                      }}
                                    >
                                      Assign
                                    </CButton>
                                  )
                                )}
                              </>
                            )}
                          {localUser.permission["update_booking_order"] && (
                            <Link
                              to={`/update-booking-orders/${item._id}`}
                              className="btn btn-primary btn-sm"
                              target="_blank"
                              onClick={(event) => event.stopPropagation()}
                            >
                              <CIcon icon={cilPencil} size="sm" />
                            </Link>
                          )}
                          {localUser.permission["delete_booking_order"] && ["pending", "cvit"].includes(item.status) && (
                            <CButton
                              color="danger"
                              size="sm"
                              onClick={(event) => {
                                event.stopPropagation();
                                handleDeleteBookingOrder(item._id);
                              }}
                            >
                              <CIcon icon={cilTrash} className="text-white" />
                            </CButton>
                          )}
                        </div>
                      </CCol>
                    </CTableDataCell>

                    <CTableDataCell className="text-center">
                      <CAvatar
                        size="md"
                        src={
                          item.createdBy.avatar
                            ? item.createdBy.avatar
                            : demoAvatar
                        }
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>{item.bookingOrderId}</div>
                    </CTableDataCell>
                    <CTableDataCell>{item.transferOrderNo}</CTableDataCell>
                    <CTableDataCell>{item.sealBag?.serialNo}</CTableDataCell>

                    <CTableDataCell className="text-capitalize">
                      {item?.country?.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.fromLocation
                        ? `${item.fromLocation.name} (${item.fromLocation.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.toLocation
                        ? `${item.toLocation.name} (${item?.toLocation?.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.type ? item.type.name : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.unit ? item.unit.name : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.tripRoute?.name}
                    </CTableDataCell>
                    <CTableDataCell className={`text-center text-capitalize ${item.priority == "emergency" ? "emergency-color" : ""}`}>
                      {item?.priority || 'Normal'}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {moment(item.pickupDate).format("DD/MM/YYYY")}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.pickupTime}
                    </CTableDataCell>

                    <CTableDataCell
                      className="text-capitalize"
                      style={{ width: "10%" }}
                    >
                      {item.remarks ? item.remarks : "N/A"}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {moment.utc(item.createdAt).local().format("DD/MM/YYYY hh:mm A")}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <NewBookingOrderActionModal
        visible={visibleNewBookingOrderActionModal}
        onConfirm={handleConfirm}
        setVisibleNewBookingOrderActionModal={
          setVisibleNewBookingOrderActionModal
        }
        text={modalText}
        selectedOption={selectedOption}
        errorText={modalErrorText}
        handleReportComment={handleReportComment}
        reportComment={reportComment}
      // addToast={addToast}
      />

      {selectedModalBookingoOrderId && (
        <SinglAssignTrip
          {...{ selectedModalBookingoOrderId, setSelectedModalBookingoOrderId }}
        />
      )}

      {bulkTripId && (
        <BulkAssignTrip
          {...{
            bulkTripId,
            setBulkTripId,
            priority:
              selectedPriorityOption &&
                selectedPriorityOption?.value === "emergency"
                ? "emergency"
                : "normal",
            country: selectedCountry?.value,
            handleCloseModal,
          }}
        />
      )}
    </>
  );
};

export default NewBookingOrdersTable;
